module.exports = __webpack_public_path__ + "media/promo/velle/images/tasty_granola-79710ca20ffbc64ddb213057ac2f74bf.png";